<template>
  <div>
    <forms-vue
      v-bind:title="title"
      v-bind:form="form"
      v-bind:submit_url="submit_url"
      v-bind:redirect_submit_url="redirect_submit_url"
      v-bind:edit_get_url="edit_get_url"
      v-bind:watch="watch"
      v-bind:submit_in_url="submit_in_url"
    ></forms-vue>
  </div>
</template>
<script type="text/javascript">
export default {
  data() {
    return {
      title: "Búsqueda de Registro",
      submit_url: this.$root.UrlBase("busqueda/reporte"),
      redirect_submit_url: "Búsqueda Registro",
      edit_get_url: "",
      submit_in_url:true,
      watch: [
        {
          watch: "value.cboTiposNC",
          route: this.$root.UrlBase("selects/init"),
          select: ["0", "0", "3", "0"],
          model: "Proceso",
          attr: "tipo_nc_codi",
        },
        {
          watch: "value.cboTiposNC",
          route: this.$root.UrlBase("selects/init"),
          select: ["0", "0", "3", "1"],
          model: "ClasificacionNC",
          attr: "tipo_nc_codi",
        },
        {
          watch: "value.cboTiposNC",
          route: this.$root.UrlBase("selects/init"),
          select: ["0", "0", "5", "1"],
          model: "FichasEtapaNC",
          attr: "tipo_nc_codi",
        },
        {
          watch: "value.cboTiposNC",
          route: this.$root.UrlBase("selects/init"),
          select: ["0", "1", "0", "0"],
          model: "FichasEtapaNC",
          attr: "tipo_nc_codi",
        },

        {
          watch: "value.cboTiposNC",
          route: this.$root.UrlBase("nc/disables"),
          select: ["0", "0", "4", "0"],
          model: "TipoNC",
          attr: [
            {
              model: "TipoNC",
              search: "codigo",
              attribute: "marca_clien_prove",
              deseado: ["A", "C"],
            },
          ],
          type: "disable",
        },
        {
          watch: "value.cboTiposNC",
          route: this.$root.UrlBase("nc/disables"),
          select: ["0", "0", "4", "1"],
          model: "TipoNC",
          attr: [
            {
              model: "TipoNC",
              search: "codigo",
              attribute: "marca_clien_prove",
              deseado: ["P", "E", "A"],
            },
          ],
          type: "disable",
        },
      ],
      form: [
        [
          {
            col: "7",
            title: "Datos de Registro",
            footer: {},
            attrs: [
              [
                {
                  pretty_name: "Tipo de Registro",
                  name: "cboTiposNC",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [],
                  cols: "6"
                },
                {
                  pretty_name: "Creador",
                  name: "cboCreadores",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [],
                  cols: "6"
                }
              ],
              [
                {
                  pretty_name: "Fecha Creación de Registron",
                  name: "FechaCreacion",
                  placeholder: "Desde",
                  desc: "text",
                  type: "title",
                  extra: "",
                  value: "",
                },
                {
                  pretty_name: "Desde",
                  name: "fechaCreacionDesdeCompleto",
                  placeholder: "Desde",
                  desc: "text",
                  type: "date",
                  extra: "",
                  value: "",
                  cols: "6",
                },
                {
                  pretty_name: "Hasta",
                  name: "fechaCreacionHastaCompleto",
                  placeholder: "Hasta",
                  desc: "text",
                  type: "date",
                  extra: "",
                  value: "",
                  cols: "6"
                },
              ],
              [
                {
                  pretty_name: "Descripción",
                  name: "descripcionFicha",
                  desc: "text",
                  type: "text",
                  extra: "",
                  value: "",
                  cols: "12",
                },
              ],

              [
                {
                  pretty_name: "Proceso",
                  name: "cboProcesos",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [],
                  cols: "6",
                },
                {
                  pretty_name: "Clasificación",
                  name: "cboClasificaciones",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [],
                  cols: "6",
                },
              ],
              [
                {
                  pretty_name: "Cliente",
                  name: "cboTipoSujetoC",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [],
                  cols: "6",
                  ajax: {
                    url: this.$root.UrlBase("clientes/list/get"),
                    filter: "razon",
                    label: "razon",
                    code: "cod",
                  },
                },
                {
                  pretty_name: "Proveedor",
                  name: "cboTipoSujetoP",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [],
                  cols: "6",
                  ajax: {
                    url: this.$root.UrlBase("proveedores/list/get"),
                    filter: "razon",
                    label: "razon",
                    code: "cod",
                  },
                },
              ],
              [
                {
                  pretty_name: "Registro Activo",
                  name: "cboMarcaVerTipoFicha",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [
                    { label: "Si", code: "A" },
                    { label: "No", code: "B" },
                  ],
                  cols: "4",
                },
                {
                  pretty_name: "Etapa Actual",
                  name: "cboEtapaActual",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [],
                  cols: "4",
                },
                {
                  pretty_name: "Estado",
                  name: "cboMarcaEstado",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [
                    { label: "En Proceso", code: "A" },
                    { label: "Finalizado", code: "C" },
                  ],
                  cols: "4",
                },
              ],
            ],
            footer: {
              buttons: [
                {
                  type: "button",
                  text: "Cancelar",
                  class: "btn btn-danger pull-left",
                  route: "HomeSections",
                }
              ],
            },
          },
          {
            col: "5",
            title: "Datos de Etapas",
            footer: {},
            attrs: [
              [
                {
                  pretty_name: "Etapa",
                  name: "cboEtapas",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [],
                  cols: "6",

                },
                {
                  pretty_name: "nc",
                  name: "nc",
                  desc: "hidden",
                  type: "hidden",
                  extra: {value:"NC"},
                  value: "RE"
                },
                {
                  pretty_name: "Responsable	",
                  name: "cboDestinatarios",
                  desc: "select",
                  type: "select",
                  extra: "",
                  value: "",
                  options: [],
                  cols: "6",
                },
              ],
              [
                {
                  pretty_name: "Fecha de Etapa",
                  name: "fechadeetapa",
                  placeholder: "Desde",
                  desc: "text",
                  type: "title",
                  extra: "",
                  value: "",
                  cols: "12",
                },
                {
                  pretty_name: "Desde",
                  name: "fechaInicioDesdeCompleto",
                  placeholder: "Desde",
                  desc: "text",
                  type: "date",
                  extra: "",
                  value: "",
                  cols: "6",
                },
                {
                  pretty_name: "Hasta",
                  name: "fechaInicioHastaCompleto",
                  placeholder: "Hasta",
                  desc: "text",
                  type: "date",
                  extra: "",
                  value: "",
                  cols: "6",
                },
              ]
            ],
            footer: {
              buttons: [
                {
                  type: "submit",
                  text: "Buscar",
                  class: "btn btn-success pull-right",
                  route: "HomeSections",
                },
              ],
            },
          },
        ],
      ],
    };
  },
  created() {
    const data = {
      selects: {
        User: {},
        TipoNC: { categoria_nc: "RE" },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.form[0][0].attrs[0][1].options = response.User;
        this.form[0][1].attrs[0][2].options = response.User;
        this.form[0][0].attrs[0][0].options = response.TipoNC;
      });
  },
  watch: {},
};
</script>
